import React from "react";
import { observer } from "mobx-react";
import { NavigateFunction } from "react-router-dom";
import {
  AuthService,
  CustomLabel,
  FlexContainer,
  IAPICommonResponse,
  IAPIResponse,
  ModalComponent,
  RedButton,
  ToastService,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { PaymentDetailModel } from "../../../shared/models";
import {  PaymentService } from "../../../shared/services";
import { InvoicePopupWrapper } from "../../../shared/styles";
import {
  PaymentMethodDescripton,
  RenderMerchantAccountName,
} from "../../../shared/components";
import { AccountSettingsStore } from "../../../shared/store";
import { GetPaymentMethodType } from "../../../shared/utils";

type IProps = {
  navigate: NavigateFunction;
  onClose: (refresh: boolean) => void;
  paymentData: PaymentDetailModel;
};

const CancelPaymentPopUp: React.FC<IProps> = ({ onClose, paymentData }) => {
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);

  function row(label: string, rightSide: React.ReactNode) {
    {
      return (
        <FlexContainer spacing={30} margin="15px">
          <CustomLabel>{label}</CustomLabel>
          <FlexContainer alignItems="center" spacing={20}>
            {rightSide}
          </FlexContainer>
        </FlexContainer>
      );
    }
  }

  function onSubmit() {
    const errorMessage = "Error cancelling payment";
    const successResposne = (response: IAPIResponse<IAPICommonResponse>) => {
      setAPIRequestPending(false);
      if (response.result.success) {
        const succesMessage = "Payment cancelled successfully";
        ToastService.showSuccess(succesMessage);
        onClose(true);
      } else {
        setAPIRequestPending(false);
        ToastService.showError(errorMessage);
      }
    };
    const errorResponse = (error: any) => {
      console.error(error);
      setAPIRequestPending(false);
      ToastService.showError(errorMessage);
    };

    PaymentService.cancelPayment(
      paymentData.id,
      AuthService.authData.accountId
    ).subscribe({
      next: successResposne,
      error: errorResponse,
    });
  }

  function body() {
    return (
      <InvoicePopupWrapper className="cancel-payment-popup">
        {row(
          "Customer",
          <CustomLabel fontWeight={"600"}>
            {paymentData.contact?.fullName || paymentData.contact?.email}
          </CustomLabel>
        )}
        {row(
          "Merchant Account",
          <RenderMerchantAccountName
            name={paymentData?.merchantAccount?.name || ""}
          />
        )}
        {paymentData.subscriptionId &&
          row(
            "Subscription",
            <CustomLabel>{paymentData.subscriptionName}</CustomLabel>
          )}
        {paymentData.invoiceNumber &&
          row(
            "Invoice",
            <CustomLabel>{paymentData.invoiceNumber}</CustomLabel>
          )}
        {row(
          GetPaymentMethodType(paymentData.paymentMethod.type),
          <PaymentMethodDescripton paymentMethod={paymentData.paymentMethod} />
        )}
        {row(
          "Scheduled Payment",
          <FlexContainer spacing={5} fxLayout="column">
            <CustomLabel fontWeight={600} color="#000">
              ${AccountSettingsStore.formatAmount(paymentData.netAmount)}
              <span className="charcoal-label font-regular"> USD</span>{" "}
            </CustomLabel>{" "}
            <CustomLabel fontWeight={600} color="#000">
              {UtilityMethods.formatDateInString(paymentData.dueDate)} ,
              {UtilityMethods.getHHMMFromDate(paymentData.dueDate)}{" "}
              {UtilityMethods.getAMPMFromDate(paymentData.dueDate)}{" "}
              <CustomLabel>
                {AccountSettingsStore.generalSettings.timeZone.abbreviation ||
                  ""}
              </CustomLabel>
            </CustomLabel>
          </FlexContainer>
        )}
      </InvoicePopupWrapper>
    );
  }
  return (
    <ModalComponent
      title={"Cancel Scheduled Payment"}
      titleFontSize="22px"
      bodyPadding="40px 45px"
      onClose={() => onClose && onClose(false)}
      showFooter={true}
      wrapperWidth="700px"
      bodyBackgroundColor="#fff"
      footerBackground="rgba(255, 0, 0, 0.1)"
      redHeader={true}
      blueHeader={false}
      footerHeight="auto"
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <RedButton
            minWidth="120px"
            height="30px"
            onClick={() => onClose(false)}
          >
            Keep Payment
          </RedButton>
          <RedButton
            disabled={isAPIRequestPending}
            primary
            minWidth="120px"
            height="30px"
            onClick={() => onSubmit()}
          >
            Cancel Payment
          </RedButton>
        </FlexContainer>
      }
    >
      {body()}
    </ModalComponent>
  );
};

export default withRouter(observer(CancelPaymentPopUp));
